import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { parseJsonBigIntIds } from '@devhacker/shared/libs/fetch/parseJsonBigIntIds';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';
import { PUSHER_API_URL } from '~/constants/config';
import { API_TIMEOUT } from '@devhacker/shared/config/general';
import { authErrorHandler } from '@/utils/errorHandlerAuth';
import { authRequestInterceptor } from '~/utils/interceptorsRequestAuth';

export const createPusherApi = ({ $logger }: any) => {
  const loggerInterceptors = createLoggerInterceptors($logger, 'pusher');
  const pusherFetch = createAxiosLikeFetch({
    baseURL: PUSHER_API_URL,
    timeout: API_TIMEOUT,
    parseResponse: parseJsonBigIntIds, // bigint-safe id + без этого API может вернуть 200 код и html
    onRequest: [loggerInterceptors.onRequest, (config) => authRequestInterceptor(config)],
    onRequestError: [
      loggerInterceptors.onRequestError,
      (config) => authErrorHandler(config, 'pusher'),
    ],
    onResponse: loggerInterceptors.onResponse,
    onResponseError: [
      loggerInterceptors.onResponseError,
      (config) => authErrorHandler(config, 'pusher'),
    ],
  });

  return {
    fetchNotifications: (_accessToken: string, integerId: string, params: any) => {
      const url = `/api/v1/kolokolchick/user/${integerId}`;
      return pusherFetch(url, { params });
    },

    resetNotifications: (integerId: string) => {
      const url = `/api/v1/kolokolchick/user/${integerId}/notifications/mass-viewing`;
      return pusherFetch(url, { method: 'patch' });
    },
  };
};
